import { useEffect } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Stats from "../components/Stats";
import GameTrial from "../components/GameTrial";
import BannerSection from "../components/BannerSection";
import {
  GamesGrid,
  HowTo,
  Testimonials,
  Pricing,
  FAQSection,
  FinalCTA,
  Footer,
} from "../components/Sections";

export default function LandingPage() {
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("visible");
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1 },
    );
    const run = () => {
      document.querySelectorAll(".reveal").forEach((el) => obs.observe(el));
    };
    run();
    const t = setTimeout(run, 300);
    return () => {
      obs.disconnect();
      clearTimeout(t);
    };
  }, []);

  return (
    <>
      <Navbar />
      <Hero />
      <Stats />
      <GameTrial />
      <BannerSection />
      <GamesGrid />
      <HowTo />
      <Pricing />
      <FAQSection />
      <FinalCTA />
      <Footer />
    </>
  );
}
